<ng-container *ngIf="hasBadRequestServiceError">
    <mm-banners *ngFor="let error of serviceErrorList" [parentForm]="standingAuthorizationDetailsGroup"
        [bannerText]="[error]" [type]="'error'" id="standingAuthDetailsWire_badRequestServiceError"
        data-testid="standingAuthDetailsWire_badRequestServiceError"></mm-banners>
</ng-container>
<mm-banners *ngIf="hasServiceError" [serviceError]="(standingAuthFormServiceError$ | async)!" [type]="'error'"
    id="standingAuthDetailsWire_serviceError" data-testid="standingAuthDetailsWire_serviceError"></mm-banners>
<mm-banners *ngIf="(wireAbaCode$ | async) === abaCodes.ABA_WITH_WARNING_TWO_INSTITUTIONS"
    [bannerText]="[intermediaryRequiredText]" [type]="'information'"></mm-banners>
<form [formGroup]="standingAuthorizationDetailsGroup" id="standing-authorizations-details-wire">
    <mm-wire-intermediary-iso [parentForm]="standingAuthorizationDetailsGroup" [wireInfo$]="wireInfo$"
        [isFromCreateTransaction]=false [wireIntermediary$]="wireIntermediary$" [countryList$]="countryList$"></mm-wire-intermediary-iso>
    <span id="header" *ngIf="!(showIntermediaryFields$ | async)" class="display-flex" [ngClass]="(useSloa$ | async)! ? 'not-active' : 'active'">Recipient bank</span>
    <mm-wire-aba [hidden]="(showIntermediaryFields$ | async)" [parentForm]="standingAuthorizationDetailsGroup" [useSloa]="(useSloa$ | async)!"
        [isFromIntermediaryInterim]=false [isFromCreateTransaction]=false [useTemplate]="(useTemplate$ | async)!" class="big-bottom-spacer" [wireInfo$]="wireInfo$"
        [wireAbaCode$]="wireAbaCode$" [wireDetailsError$]="wireDetailsErrorStandingAuth$"
        [wireDetailsWarning$]="wireDetailsWarningStandingAuth$">
    </mm-wire-aba>
    <mm-wire-recipient [parentForm]="standingAuthorizationDetailsGroup" (recipientSelectionComplete)="isRecipientValid($event)">
    </mm-wire-recipient>
    <div class="container" *ngIf="validRecipient">
        <mm-wire-iso-receiving-account-holder [parentForm]="standingAuthorizationDetailsGroup"
            [isFromCreateTransaction]=false [receivingAccountHolder]="(receivingAccountHolderIso$ | async)!"
            [firstParty$]="firstParty$" [countryList$]="countryList$"
            [missingThirdPartyAddress]="(missingThirdPartyAddress$ | async)!" [firstPartyPayees]="(firstPartyPayees$ | async)!"
            [payeeName$]="payeeName$!" [modifiedPayeeCheckbox$]="modifiedPayeeCheckBox$!"
            [isoModifiedPayeeName$]="isoModifiedPayeeName$!" [isFromEditReview]="(isFromEditReview | async) ?? false">
        </mm-wire-iso-receiving-account-holder>
        <hr *ngIf="isIrsAba" class="bottom-divider">
      <mm-wire-irs-tax-details [parentForm]="standingAuthorizationDetailsGroup" *ngIf="isIrsAba"
            [isFromCreateTransaction]=false [taxRemittance$]="taxRemittance$">{{isIrsAba}} Tax Remittance
        </mm-wire-irs-tax-details>
        <hr *ngIf="!isIrsAba && (isIra$ | async)">
        <mm-sa-wire-tax-withholdings *ngIf="(isIra$ | async)"
            [parentForm]="standingAuthorizationDetailsGroup"></mm-sa-wire-tax-withholdings>
        <hr *ngIf="!isIrsAba || (isIra$ | async)" id="bottom-divider">
        <mm-wire-transmission-notes [parentForm]="standingAuthorizationDetailsGroup"
            [canDisplayCreditToInfo]="(canDisplayCreditToInfo$ | async)!" id="transactionDetailsWire_transmissionNotes"
            class="big-bottom-spacer" class="big-bottom-spacer">
        </mm-wire-transmission-notes>
        <mm-wire-authorization-nickname
            [parentForm]="standingAuthorizationDetailsGroup"></mm-wire-authorization-nickname>
    </div>
</form>
